/* eslint-disable no-unneeded-ternary */
/* eslint-disable no-nested-ternary */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "src/modules/notification";
import { getApprovalAvailableAccessRight } from "src/modules/approvals/redux";
import CompanyApprovalDialogComponent from "./company-approval-dialog.component";
import AccessRights from "../../../../../configs/constants/accessRights";
import { getModuleListing } from "../../../../bundles/redux/bundles.action";
import { getBundleOptions } from "../../../../companies/redux";

export default function CompanyApprovalDialogContainer({
  industries,
  selectedCompany,
  onCompanyApprovalDialogSubmitClick,
  onCompanyApprovalDialogCloseClick,
  plans,
}) {
  const dispatch = useDispatch();
  const isFetching = useSelector((state) =>
    selectLoading(state, getBundleOptions.typePrefix)
  );
  const [selectedPlan, setSelectedPlan] = useState(null);
  const canEdit = useSelector((state) => state.session.accessRights.includes(AccessRights.APPROVAL_EDIT));

  const bundleOptions = useSelector((state) => state.companies.bundleOptions);
  // The bundle only carries module ids; the catalogue turns them into cards.
  const moduleListing = useSelector((state) => state.bundles.moduleListing);
  // Whether the two catalogues have ever come back — not whether they have anything in them.
  // The step needs the difference to tell "still loading" from "there are no bundles yet",
  // exactly as the two company surfaces do.
  const isLoaded = useSelector((state) => state.companies.bundleOptionsLoaded
    && state.bundles.moduleListingLoaded);
  // Either catalogue read was rejected. Only acted on while nothing has ever loaded — the
  // difference between "wait" and "waiting will not help".
  const hasFailed = useSelector((state) => state.companies.bundleOptionsFailed
    || state.bundles.moduleListingFailed);

  const loadCatalogues = () => {
    dispatch(getBundleOptions());
    dispatch(getModuleListing());
  };

  useEffect(() => {
    loadCatalogues();
  }, []);

  useEffect(() => {
    if (selectedCompany) {
      dispatch(
        getApprovalAvailableAccessRight({
          uuid: selectedCompany.company.id,
          plan: selectedPlan
            ? selectedPlan.name
            : plans.length
            ? plans[0].name
            : "pro",
        })
      );
    }
  }, [selectedCompany, selectedPlan]);

  useEffect(() => {
    if (plans.length) setSelectedPlan(plans[0]);
    else setSelectedPlan(null);
  }, [plans]);

  return (
    <CompanyApprovalDialogComponent
      industries={industries}
      selectedCompany={selectedCompany}
      onCompanyApprovalDialogSubmitClick={onCompanyApprovalDialogSubmitClick}
      onCompanyApprovalDialogCloseClick={onCompanyApprovalDialogCloseClick}
      plans={plans}
      isFetching={isFetching}
      setSelectedPlan={setSelectedPlan}
      selectedPlan={selectedPlan}
      canEdit={canEdit}
      bundleOptions={bundleOptions}
      moduleListing={moduleListing}
      isLoaded={isLoaded}
      hasFailed={hasFailed}
      onRetryCatalogues={loadCatalogues}
    />
  );
}
